export default __webpack_public_path__ + "static/media/gs-6.0a6e355d.png";